import { IDateItemBean } from "../../../infrastructure/document/ver2/beans/items";
import { ScreenKinds } from "../../his/behavior";
import { RelationalActionKinds } from "..";
import { DateInputMethodKinds } from "../inputMethodKinds";

export type DateInputMethodOptionKinds
  = "Normal"         // 通常
  | "Link"           // 時刻オブジェクトからの連動
  | "Calculate"      // 日付計算
  | "HisItem"        // HIS項目（フリー入力不可）
  | "HisFreeInput"   // HIS項目（フリー入力可能）
  | "HisInfoSelect"  // HIS情報選択(HIS項目で選択画面があるもの)
  | "UserDefinition"; // ユーザ定義

const deciders: { [K in DateInputMethodOptionKinds]: (bean: IDateItemBean) => boolean } = {
  Normal:         undefined, // otherwiseで返すので定義しない
  Link:           undefined, // otherwiseで返すので定義しない
  Calculate:      bean => (bean.relationalItems != null && bean.relationalItems.find(x => x.relationalActionType === RelationalActionKinds.Calculate) != null),
  HisItem:        bean => (bean.hisItemParameter != null && bean.hisItemParameter.screenType === ScreenKinds.None && !bean.supportedFreeText),
  HisFreeInput:   bean => (bean.hisItemParameter != null && bean.hisItemParameter.screenType === ScreenKinds.None && bean.supportedFreeText),
  HisInfoSelect:  bean => (bean.hisItemParameter != null && bean.hisItemParameter.screenType !== ScreenKinds.None),
  UserDefinition: bean => (bean.sourceFile != null),
};

const defaultInputMethodKinds: { [K in DateInputMethodOptionKinds]: DateInputMethodKinds } = {
  Normal:         DateInputMethodKinds.Calendar,
  Link:           DateInputMethodKinds.None,
  Calculate:      DateInputMethodKinds.Calculate,
  HisItem:        DateInputMethodKinds.None,
  HisFreeInput:   DateInputMethodKinds.None,
  HisInfoSelect:  DateInputMethodKinds.HisInfoSelect,
  UserDefinition: DateInputMethodKinds.UserDefinitionSelect,
};

const hasDictionaryProperty = (key: string): key is DateInputMethodOptionKinds => deciders.hasOwnProperty(key);

export namespace DateInputMethodOptionKinds {
  export const Normal: DateInputMethodOptionKinds = "Normal";
  export const Link: DateInputMethodOptionKinds = "Link";
  export const Calculate: DateInputMethodOptionKinds = "Calculate";
  export const HisItem: DateInputMethodOptionKinds = "HisItem";
  export const HisFreeInput: DateInputMethodOptionKinds = "HisFreeInput";
  export const HisInfoSelect: DateInputMethodOptionKinds = "HisInfoSelect";
  export const UserDefinition: DateInputMethodOptionKinds = "UserDefinition";

  export const toInputMethodOptionKinds = (bean: IDateItemBean): DateInputMethodOptionKinds => {
    for (const key in deciders) {
      if (hasDictionaryProperty(key) && deciders[key] != null && deciders[key](bean)) {
        return key;
      }
    }
    return bean.isManualInputSuppressed
      ? Link
      : Normal;
  };

  export const getDefualtInputMethodKind = (optionKind: DateInputMethodOptionKinds): DateInputMethodKinds => {
    return defaultInputMethodKinds[optionKind];
  };
}
